import { SigningModeType } from '@fiverr-private/identification_core';
import { Experiments } from '../../shared/constants/experiments';

export interface ExtendedMixpanelEventProperties {
    identificationIllustrationExperiment: number;
}

export const MIXPANEL_EXTENDED_PROPERTIES_MAP = {
    identificationIllustrationExperiment: `Experiment ${Experiments.LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT}`,
} as const satisfies Record<keyof ExtendedMixpanelEventProperties, string>;

export const MIXPANEL_SIGNING_MODE_TYPE_MAP = {
    sign_in: 'Sign In',
    sign_up: 'Sign Up',
} as const satisfies Record<SigningModeType, string>;
